import router from './init'

router.beforeEach((to, from, next) => {

  const nonAuthPage = ['/login']
  const isAuthenticated = localStorage.getItem('token') ? true : false

  if (to.matched.some(route => !nonAuthPage.includes(route.path))) {
    // matched auth page
    if (!isAuthenticated) {
      next('/login')
    } else {
      next()
      // next(store.state.user.userData.roles[0].Menus[0].Url)
    }
  } else {
    // matched non auth page
    if (isAuthenticated) {
      next('/')
    } else {
      next()
    }
  }

  // set page title
  document.title = process.env.VUE_APP_TITLE + ' | ' + to.name
})

export default router
